import Image from 'next/legacy/image'

import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Row from '@ilg-totallymoney/ui/components/Row'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'

import totallySureLogo from '@images/TotallySure-logo.png'

import {
    StyledButton,
    StyledImageContainer,
} from './ScoredCardDetailsTotallySureTooltipBanner.styled'

const ScoredCardDetailsTotallySureTooltipBanner = ({
    onClick,
}: {
    onClick: () => void
}) => (
    <StyledButton
        aria-label="Opens a modal that explains what TotallySure offers means"
        onClick={onClick}
    >
        <Flex alignItems="center" position="relative" right={0}>
            <Flex
                justifyContent="space-between"
                position="relative"
                py="space10"
                px="space20"
                width={['100%', '95%']}
                borderRadius={[0, 'borderRadius10']}
                backgroundColor="eligibilityLevel0-100"
            >
                <Box
                    display={['flex', 'none']}
                    alignItems="center"
                    mr="space10"
                >
                    <Image
                        src={totallySureLogo}
                        alt="TotallySure logo"
                        width={90}
                        height={40}
                    />
                </Box>

                <Row
                    justifyContent={['space-between', 'flex-start']}
                    alignItems={['unset', 'center']}
                    space="space10"
                    flex={1}
                >
                    <Stack space={[0, 'space05']} direction={['column', 'row']}>
                        <Text
                            variant="80"
                            color="white"
                            weight="bold"
                            textAlign="left"
                        >
                            Includes pre-approval and guarantees
                        </Text>

                        <Text variant="80" color="white" textAlign="left">
                            (subject to final checks)
                        </Text>
                    </Stack>

                    <Flex alignSelf="center">
                        <Icon icon="tooltip" size={20} color="white" />
                    </Flex>
                </Row>
            </Flex>

            <StyledImageContainer
                display={['none', 'flex']}
                position="absolute"
                right={0}
            >
                <Image
                    src={totallySureLogo}
                    alt="TotallySure logo"
                    width={145}
                    height={64}
                />
            </StyledImageContainer>
        </Flex>
    </StyledButton>
)

export default ScoredCardDetailsTotallySureTooltipBanner
